
    <button class="btn-link" (click)="redirect()">
      {{ label }}
    </button>
  